import { createSelector } from 'reselect';

export const partnersSelector = createSelector(
    (state) => state && state.realEstate && state.realEstate.partners,
    (partners) => partners || [],
);

export const housesSelector = createSelector(
    (state) => state && state.realEstate && state.realEstate.houses,
    (houses) => houses || [],
);

export const currentPersonIdSelector = createSelector(
    (state) => state && state.realEstate && state.realEstate.currentPersonId,
    (id) => id || null,
);

export const roleSelector = createSelector(
    (state) => state && state.realEstate && state.realEstate.role,
    (role) => role || null,
);

export const canSeeAllSelector = createSelector(
    (state) => state && state.realEstate && state.realEstate.canSeeAll,
    (v) => !!v,
);

export const addableUsersSelector = createSelector(
    (state) => state && state.realEstate && state.realEstate.addableUsers,
    (u) => u || [],
);
